import { AUTO_LOCK_RULES_ACTION_TYPE } from '../actions';

const initialState = {};

const autoLockRulesSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case AUTO_LOCK_RULES_ACTION_TYPE.GET_AUTO_LOCK_RULES_SCHEMA:
      return payload || state;

    default:
      return state;
  }
};

export default autoLockRulesSchemaReducer;
